import { render, staticRenderFns } from "./companyList.vue?vue&type=template&id=82a00b4c&scoped=true"
import script from "./companyList.vue?vue&type=script&lang=js"
export * from "./companyList.vue?vue&type=script&lang=js"
import style0 from "./companyList.vue?vue&type=style&index=0&id=82a00b4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82a00b4c",
  null
  
)

export default component.exports